export const RolesTranslation = {
  admin: 'Admin',
  coordinator: 'Koordynator',
};
